module.exports = __webpack_public_path__ + "open-sans-latin-600italic.5eb91803ad12758ca654.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600italic.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600italic.svg
// module chunks = 1 3